import type { InternalSliceData } from '../types/internal/pie-chart.js';

export function getSlicesMap(data: InternalSliceData[]) {
  const sliceMap = new Map<string, InternalSliceData>();

  data.forEach((slice) => {
    sliceMap.set(slice.id, slice);
  });

  return sliceMap;
}
